module.exports = __webpack_public_path__ + "img/jd_black.6e8dd63c.png";